import * as React from 'react';
import { SVGProps } from 'react';

const SvgWellBeing = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
    <path
      fill={props.fill}
      d="m29.3 9.1-2.6 2.6v5.4l5.3-5.4-2.7-2.6zM18.5 6v3.8l3.8 3.8V6h-3.8zm-9.8 5.6 2.6 2.7h5.4l-5.3-5.4-2.7 2.7zM31 18.3l-3.8 3.9h7.6v-3.9H31zM6 22.2h3.8l3.8-3.9H6v3.9zm5.5 9.3 2.6-2.6v-5.4l-5.3 5.3 2.7 2.7zm10.8 3.1v-3.8L18.5 27v7.6h3.8zm9.8-5.6-2.6-2.7h-5.4l5.3 5.4 2.7-2.7z"
    />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth={1.5}
      d="M25.1 20.3a4.7 4.7 0 1 1-9.4 0 4.7 4.7 0 0 1 9.4 0z"
    />
  </svg>
);

export default SvgWellBeing;
